import { paymentActionTypes } from '../actions/types';

const initialState = {
    payments: [],
    loading: false,
    error: null,
};

export function payment(state = initialState, action) {
    switch (action.type) {
        case paymentActionTypes.RESET_STATE:
            return {
                ...initialState,
            };
        case paymentActionTypes.REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case paymentActionTypes.REPORT_SUCCESS:
            return {
                ...state,
                payments: action.payments,
                loading: false,
                error: null,
            };
        case paymentActionTypes.REPORT_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        default:
            return state;
    }
}
